export default __webpack_public_path__ + "static/media/AddUserIcon.f99ca5d7.svg";